export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Round-the-clock customer service to address your logistics needs anytime, anywhere.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Real-time Tracking',
      description: 'Monitor your shipments with advanced GPS tracking technology for complete visibility.',
    },
    {
      icon: 'ri-map-2-line',
      title: 'Nationwide Coverage',
      description: 'Extensive network across the United States ensuring timely deliveries to any location.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-6xl font-serif text-gray-900">
            Why Choose<br />
            <span className="text-[#E67E50]">Next Phase</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="border-2 border-[#E67E50] rounded-2xl overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer"
            >
              <div className="bg-white p-8 h-64 flex flex-col items-center justify-center text-center">
                <div className="w-20 h-20 rounded-full bg-[#F5A962] flex items-center justify-center mb-6">
                  <i className={`${benefit.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-serif font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
              </div>
              <div className="bg-[#F4E8D8] p-8">
                <p className="text-gray-600 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
